module.exports = __webpack_public_path__ + "static/media/13.f5660f0f.webp";